import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
// @ts-ignore
import { Show, Hide, Button } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { AUTO_ATTR_KEY, AutomationId } from 'utils/automationUtil'
import { ActionIconStyles, StyledIconContainer } from '../index.css'

const StyledMediaIcon = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.soundbiteDefaultFrame.mediaIcon
})`
  ${ActionIconStyles}
`

const MediaIcon = ({
  children,
  callback,
  wording
}: {
  children: React.ReactElement
  callback: () => void
  wording: string
}) => {
  const theme = useDisplayTheme() as Theme

  const handleCallback = (event: React.MouseEvent) => {
    event.stopPropagation()
    if (callback) {
      callback()
    }
  }

  return (
    <Button mode={theme} variant="ghost" onClick={handleCallback}>
      <StyledMediaIcon mode={theme}>
        <StyledIconContainer>{children}</StyledIconContainer>
        {wording}
      </StyledMediaIcon>
    </Button>
  )
}
export const ShowMediaIcon = ({ callback }: { callback: () => void }) => {
  const { t } = useTranslation()
  const theme = useDisplayTheme() as Theme
  const color = sys[theme].text.placeholder

  return (
    <MediaIcon callback={callback} wording={t('showMedia')}>
      <Show color={color} />
    </MediaIcon>
  )
}

export const HideMediaIcon = ({ callback }: { callback: () => void }) => {
  const { t } = useTranslation()
  const theme = useDisplayTheme() as Theme
  const color = sys[theme].text.placeholder

  return (
    <MediaIcon callback={callback} wording={t('hideMedia')}>
      <Hide color={color} />
    </MediaIcon>
  )
}
